import { render, staticRenderFns } from "./topMenu.vue?vue&type=template&id=c23a8a62&scoped=true&"
import script from "./topMenu.vue?vue&type=script&lang=js&"
export * from "./topMenu.vue?vue&type=script&lang=js&"
import style0 from "./topMenu.vue?vue&type=style&index=0&id=c23a8a62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a8a62",
  null
  
)

export default component.exports